import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: '26px 0 26px 0',
  },
  confirmModalHeader: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#2E2E32',
    lineHeight: '18px',
    padding: '0 24px',
    marginBottom: '16px',
  },
  confirmModalContent: {
    fontSize: '20px',
    color: '#616581',
    marginTop: '24px',
    padding: '0 24px',
    lineHeight: '24px',
    marginBottom: '0px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '24px',
    padding: '0 24px',
    gap: '10px',
    borderTop: '1px solid #E0E0E0',
    paddingTop: '25px',
  },
  createButton: {
    padding: '8px 12px',
    border: 0,
    background: '#00A0E3',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'var(--color-white)',
    fontSize: '16px',
    fontWeight: '500',
    minWidth: '147px',
  },
  cancelButton: {
    padding: '8px 12px',
    border: '1px solid #00A0E3',
    background: 'var(--color-white)',
    borderRadius: 10,
    cursor: 'pointer',
    color: '#00A0E3',
    fontSize: '16px',
    fontWeight: '500',
    minWidth: '147px',
  },
})

const ChangeAIModelConfirmModal = ({ classes, modelName, onConfirm, onCancel }) => {
  return (
    <div className={classes.modalContainer}>
      <h2 className={classes.confirmModalHeader}>Change AI Model</h2>
      <p className={classes.confirmModalContent}>
        Are you sure you want to switch to '{modelName}'? Future responses will
        be generated using this AI model.
      </p>
      <div className={classes.buttonContainer}>
        <button className={classes.cancelButton} onClick={onCancel}>
          No, Cancel
        </button>
        <button className={classes.createButton} onClick={onConfirm}>
          Yes, Change model
        </button>
      </div>
    </div>
  )
}

ChangeAIModelConfirmModal.propTypes = {
  classes: PropTypes.object.isRequired,
  modelName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default withStyles(styles, { withTheme: true })(ChangeAIModelConfirmModal)
